import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shareIcon",
  "use": "icon-shareIcon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shareIcon\">\n<g id=\"icon-shareIcon_&#229;&#136;&#134;&#228;&#186;&#171;\">\n<path id=\"icon-shareIcon_Rectangle 3761\" d=\"M10 5H6C4.89543 5 4 5.89543 4 7V13C4 14.1046 4.89543 15 6 15H14C15.1046 15 16 14.1046 16 13V12M12.5 5H15C15.5523 5 16 5.44772 16 6V8.5M8 9.5H10.5C11.759 9.5 12.9446 8.90722 13.7 7.9L15.5 5.5\" stroke=\"#333333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol